export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "show_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ver"])},
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de agro exportadoras"])}
        }
      },
      "en": {
        "labels": {
          "show_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Show"])},
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go back to list of agro exporters"])}
        }
      }
    }
  })
}